<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :actions="actions"
      :title="title"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
      :beforeSetupGrid="beforeSetupGrid"
      :selectionEnabled="true"
      ref="grid"
    ></dx-grid>

    <v-dialog persistent v-model="addNewRouteDialog" max-width="1000">
      <v-card class="pa-3">
        <v-card-title class="headline pl-1 pt-0"
          >New Route - Season: {{ newRoute.season }}</v-card-title
        >

        <v-layout row>
          <v-layout column xs6 class="pr-2" style="min-width: 50%">
            <v-text-field
              class="mx-2 mb-2"
              v-model="newRoute.description"
              label="Description"
              ref="newDescription"
              :rules="[rules.required]"
            ></v-text-field>
            <v-select
              class="mx-2 mb-2"
              v-model="newRoute.direction"
              label="Direction"
              ref="newDirection"
              :rules="[rules.required]"
              :items="['Pickup', 'Dropoff']"
            ></v-select>
            <v-select
              class="mx-2 mb-2"
              v-model="newRoute.buildings"
              label="Buildings"
              ref="newBuildings"
              :items="buildingList"
              multiple
              :rules="[rules.required]"
              :menu-props="{ closeOnContentClick: true }"
            ></v-select>
            <v-select
              class="mx-2 mb-2"
              v-model="newRoute.grades"
              label="Grades"
              ref="newGrades"
              :items="gradeList"
              multiple
              :rules="[rules.required]"
            ></v-select>
            <v-select
              class="mx-2 mb-2"
              v-model="newRoute.weekDays"
              label="Weekdays"
              ref="newWeekdays"
              :items="weekDayList"
              multiple
            ></v-select>

            <!-- <v-select
                            class="mx-2 mb-2"
                            v-model="newRoute.term"
                            label="Term"
                            ref="newTerm"
                            :items="terms"
                            :rules="[rules.required]"
                        ></v-select> -->
            <v-layout row class="mb-2">
              <div class="font-weight-regular ml-2 pt-2 pb-1">
                Time Start:
              </div>
              <DxDateBox
                type="time"
                picker-type="list"
                :interval="12"
                class="mx-2 mb-0"
                v-model="newRoute.timeStart"
                :rules="[rules.required]"
              />
            </v-layout>

            <v-text-field
              class="mx-2 mb-0"
              v-model="newRoute.notes"
              label="Notes"
              ref="notes"
            ></v-text-field>
            <v-text-field
              class="mx-2 mb-0"
              v-model="newRoute.color"
              label="Color"
              ref="color"
            ></v-text-field>
            <v-layout row>
              <v-text-field
                class="mx-2 mb-0"
                v-model="newRoute.routeIdentifier"
                label="Route Identifier"
                ref="newRouteIdentifier"
                :rules="[rules.required]"
              ></v-text-field>
              <v-select
                class="mx-2 mb-0"
                v-model="newRoute.groupBy"
                label="Group"
                ref="newGroupBy"
                :rules="[rules.required]"
                :items="['AM', 'PM', 'CUSTOM', 'FAM', 'PPM']"
              ></v-select>
            </v-layout>
            <v-autocomplete
              class="mx-2 mb-0"
              v-model="newRoute.geoSchedule"
              label="Geo Schedule"
              :items="getGeoScheduleOptions(newRoute.geoSchedule)"
              clearable
            ></v-autocomplete>
            <v-checkbox
              v-model="newRoute.goeNotRequired"
              class="mx-2 mt-0"
              label="GOE Not Required"
              color="success"
              hide-details
            ></v-checkbox>
          </v-layout>
          <v-layout column xs6 class="pl-2" style="min-width: 50%">
            <div v-for="(routeSchedule, index) in newRoute.routeSchedules">
              <v-layout row align-center>
                <v-layout column class="mr-2">
                  <v-layout row>
                    <v-autocomplete
                      class="mx-1"
                      label="Driver / Bus"
                      v-model="routeSchedule.driver_bus"
                      :items="driver_busList.map((b) => b.displayName)"
                      ref="newRouteDriver_bus"
                      :rules="[
                        (value) =>
                          rules.busDriverRequired(value, routeSchedule),
                      ]"
                    ></v-autocomplete>
                    <!-- <v-btn-toggle
                                            mandatory
                                            v-model="routeSchedule.type"
                                            class="toggle-button-group ml-2 mt-3"
                                            style="height: 29px;"
                                        >
                                            <v-btn
                                                flat
                                                value="Default"
                                                class="toggle-button default-schedule-button"
                                            >
                                                Default
                                            </v-btn>
                                            <v-btn
                                                flat
                                                value="Sub"
                                                class="toggle-button sub-schedule-button"
                                            >
                                                Sub
                                            </v-btn>
                                        </v-btn-toggle> -->
                  </v-layout>
                  <v-layout row>
                    <v-menu
                      v-model="routeSchedule.dateFromPickerMenu"
                      :close-on-content-click="true"
                      offset-y
                      full-width
                      prepend-icon="mdi-currency-usd"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="routeSchedule.dateFrom"
                          :value="formatedDate(routeSchedule.dateFrom)"
                          label="From Date"
                          prepend-icon="mdi-calendar"
                          v-on="on"
                          clearable
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="routeSchedule.dateFrom"
                      ></v-date-picker>
                    </v-menu>
                    <v-menu
                      v-model="routeSchedule.dateToPickerMenu"
                      :close-on-content-click="true"
                      offset-y
                      full-width
                      prepend-icon="mdi-currency-usd"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="routeSchedule.dateTo"
                          :value="formatedDate(routeSchedule.dateTo)"
                          label="To Date"
                          prepend-icon="mdi-calendar"
                          v-on="on"
                          clearable
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="routeSchedule.dateTo"
                      ></v-date-picker>
                    </v-menu>
                  </v-layout>
                  <v-select
                    class="mb-2 mx-1"
                    v-model="routeSchedule.term"
                    label="Term"
                    ref="routeScheduleTerm"
                    :items="terms"
                    :rules="[rules.required]"
                  ></v-select>
                </v-layout>

                <!-- <v-btn
                                    class="pt-0 mt-0"
                                    @click.stop="addRouteSchedule"
                                    flat
                                    icon
                                    color="success"
                                >
                                    <v-icon>mdi-plus-circle</v-icon>
                                </v-btn>
                                <v-btn
                                    class="pt-0 mt-0"
                                    @click.stop="removeRouteSchedule(index)"
                                    flat
                                    icon
                                    color="#f55a4e"
                                >
                                    <v-icon>mdi-minus-circle-outline</v-icon>
                                </v-btn> -->
              </v-layout>
            </div>
          </v-layout>
        </v-layout>

        <v-card-actions class="mx-0 pt-3 px-2 pb-2 mt-3">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="closeAddRouteDialog()"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" color="success" @click="saveNewRoute()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="updateRouteDialog" max-width="1000">
      <update-route
        ref="updateRouteDialog"
        :rowClicked="rowClicked"
        :driver_busList="driver_busList"
        :geoScheduleOptions="geoScheduleOptions"
        :loadRouteSchedules="loadRouteSchedules"
        :reloadGrid="reloadGrid"
        :terms="terms"
        :buildingList="buildingList"
        :gradeList="gradeList"
        :closeUpdateRouteDialog="closeUpdateRouteDialog"
      ></update-route>
    </v-dialog>

    <v-dialog persistent v-model="updateGroupAndIdDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0"
          >Update Group & ID</v-card-title
        >
        <v-text-field
          class="mb-0"
          v-model="routeIdentifier"
          label="Route Identifier"
          ref="routeIdentifier"
          :rules="[rules.required]"
        ></v-text-field>
        <v-select
          class="mb-0"
          v-model="groupBy"
          label="Group"
          ref="groupBy"
          :rules="[rules.required]"
          :items="['AM', 'PM', 'CUSTOM', 'FAM', 'PPM']"
        ></v-select>
        <v-card-actions class="mx-0 pr-0 pb-2 mt-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="updateGroupAndIdDialog = false"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" color="success" @click="saveGroupAndID">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="updateGeoScheduleDialog" max-width="500">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0 pb-2"
          >Update Geo Schedule</v-card-title
        >

        <div class="caption grey--text mb-1">
          {{ selected.length }} route(s) selected
        </div>
        <div
          style="max-height: 220px; overflow-y: auto; border: 1px solid #e0e0e0; border-radius: 4px;"
          class="mb-3"
        >
          <div
            v-for="(route, index) in selected"
            :key="route.id"
            class="px-3 py-2"
            :style="index < selected.length - 1 ? 'border-bottom: 1px solid #f0f0f0;' : ''"
          >
            <v-layout row align-center>
              <v-layout column style="flex: 1; min-width: 0;">
                <div class="body-2 font-weight-medium" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  {{ route.description || '—' }}
                </div>
                <div class="caption grey--text mt-1" style="line-height: 1.5;">
                  <span v-if="route.direction">{{ route.direction }}</span>
                  <span v-if="route.routeIdentifier"> · {{ route.routeIdentifier }}</span>
                  <span v-if="route.groupBy"> · {{ route.groupBy }}</span>
                </div>
                <div class="caption mt-1" style="color: #9e9e9e; display: flex; flex-wrap: wrap; gap: 6px;">
                  <span v-if="route.driver" style="display: inline-flex; align-items: flex-start; gap: 2px;">
                    <v-icon style="font-size: 11px; color: #9e9e9e; margin-top: 2px; flex-shrink: 0;">mdi-account</v-icon>
                    <span>{{ route.driver }}</span>
                  </span>
                  <span v-if="route.busNumber" style="display: inline-flex; align-items: flex-start; gap: 2px;">
                    <v-icon style="font-size: 11px; color: #9e9e9e; margin-top: 2px; flex-shrink: 0;">mdi-bus</v-icon>
                    <span>{{ route.busNumber }}</span>
                  </span>
                  <span v-if="route.weekDays" style="display: inline-flex; align-items: flex-start; gap: 2px;">
                    <v-icon style="font-size: 11px; color: #9e9e9e; margin-top: 2px; flex-shrink: 0;">mdi-calendar-week</v-icon>
                    <span>{{ route.weekDays }}</span>
                  </span>
                </div>
              </v-layout>
              <div v-if="route.geoSchedule" class="caption ml-3" style="white-space: nowrap; color: #757575; flex-shrink: 0;">
                {{ route.geoSchedule }}
              </div>
            </v-layout>
          </div>
        </div>

        <v-autocomplete
          class="mb-0"
          v-model="bulkGeoSchedule"
          label="Geo Schedule"
          :items="geoScheduleOptions"
          clearable
          hide-details
        ></v-autocomplete>

        <v-card-actions class="mx-0 pr-0 pb-2 mt-3">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="updateGeoScheduleDialog = false"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" color="success" @click="saveGeoSchedule">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="routeScheduleEditDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0"
          >Update Route Schedule</v-card-title
        >
        <v-autocomplete
          class="mx-1"
          label="Driver / Bus"
          v-model="routeScheduleToEdit.driver_bus"
          :items="driver_busList.map((b) => b.displayName)"
          ref="driver_bus"
          :rules="[
            (value) => rules.busDriverRequired(value, routeScheduleToEdit),
          ]"
        ></v-autocomplete>
        <v-menu
          v-model="routeScheduleToEdit.dateFromPickerMenu"
          :close-on-content-click="true"
          offset-y
          full-width
          prepend-icon="mdi-currency-usd"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="routeScheduleToEdit.dateFrom"
              :value="formatedDate(routeScheduleToEdit.dateFrom)"
              label="Start Date"
              prepend-icon="mdi-calendar"
              clearable
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="routeScheduleToEdit.dateFrom"></v-date-picker>
        </v-menu>
        <v-menu
          v-model="routeScheduleToEdit.dateToPickerMenu"
          :close-on-content-click="true"
          offset-y
          full-width
          prepend-icon="mdi-currency-usd"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="routeScheduleToEdit.dateTo"
              :value="formatedDate(routeScheduleToEdit.dateTo)"
              label="End Date"
              prepend-icon="mdi-calendar"
              clearable
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="routeScheduleToEdit.dateTo"></v-date-picker>
        </v-menu>
        <v-select
          class="mb-2"
          v-model="routeScheduleToEdit.term"
          label="Term"
          ref="routeScheduleTerm"
          :items="terms"
          :rules="[rules.required]"
        ></v-select>
        <v-card-actions class="mx-0 pr-0 pb-2 mt-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="routeScheduleEditDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click="
              saveRouteSchedule({
                routeSchedule: routeScheduleToEdit,
              })
            "
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card></v-dialog
    >

    <v-dialog persistent v-model="addRouteScheduleDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0"
          >Add Route Schedule</v-card-title
        >
        <v-autocomplete
          class="mx-1"
          label="Driver / Bus"
          v-model="routeScheduleToAdd.driver_bus"
          :items="driver_busList.map((b) => b.displayName)"
          ref="driver_bus"
          :rules="[
            (value) => rules.busDriverRequired(value, routeScheduleToAdd),
          ]"
        ></v-autocomplete>
        <v-menu
          v-model="routeScheduleToAdd.dateFromPickerMenu"
          :close-on-content-click="true"
          offset-y
          full-width
          prepend-icon="mdi-currency-usd"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="routeScheduleToAdd.dateFrom"
              :value="formatedDate(routeScheduleToAdd.dateFrom)"
              label="Start Date"
              prepend-icon="mdi-calendar"
              clearable
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="routeScheduleToAdd.dateFrom"></v-date-picker>
        </v-menu>
        <v-menu
          v-model="routeScheduleToAdd.dateToPickerMenu"
          :close-on-content-click="true"
          offset-y
          full-width
          prepend-icon="mdi-currency-usd"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="routeScheduleToAdd.dateTo"
              :value="formatedDate(routeScheduleToAdd.dateTo)"
              label="End Date"
              prepend-icon="mdi-calendar"
              clearable
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="routeScheduleToAdd.dateTo"></v-date-picker>
        </v-menu>
        <v-select
          class="mb-2"
          v-model="routeScheduleToAdd.term"
          label="Term"
          ref="routeScheduleTerm"
          :items="terms"
          :rules="[rules.required]"
        ></v-select>
        <v-card-actions class="mx-0 pr-0 pb-2 mt-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="addRouteScheduleDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click="
              saveRouteSchedule({
                routeSchedule: routeScheduleToAdd,
              })
            "
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card></v-dialog
    >

    <v-dialog persistent v-model="routeScheduleDeleteDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0"
          >Delete Route Schedule</v-card-title
        >

        <div
          class="pa-2 mb-2"
          style="border: #5cb860 1px solid; border-radius: 5px;"
        >
          <v-layout row class="mb-2">
            <div class="font-weight-medium mr-2 pt-2">
              Driver Bus:
            </div>
            <div class="pt-2">
              {{ routeScheduleToDelete.driver_bus }}
            </div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium mr-2">
              Start Date:
            </div>
            <div>
              {{ routeScheduleToDelete.dateFrom }}
            </div> </v-layout
          ><v-layout row class="mb-2">
            <div class="font-weight-medium mr-2">
              End Date:
            </div>
            <div>
              {{ routeScheduleToDelete.dateTo }}
            </div> </v-layout
          ><v-layout row class="mb-2">
            <div class="font-weight-medium mr-2">
              Term:
            </div>
            <div>{{ routeScheduleToDelete.term }}</div>
          </v-layout>
        </div>

        <v-card-actions class="mr-0 mt-3">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="routeScheduleDeleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click="deleteRouteSchedule"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="deleteDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Delete Routes</v-card-title>
        <div class="font-weight-regular">
          The {{ selected.length }} selected routes will be deleted
        </div>
        <v-card-actions class="mr-0 mt-3">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="deleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" color="success" @click="deleteRoutes">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="addRouteSchedulesInBulkDialog"
      max-width="400"
    >
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0"
          >Add Route Schedule</v-card-title
        >
        <v-autocomplete
          class="mx-1"
          label="Driver / Bus"
          v-model="addRouteSchedulesInBulk.driver_bus"
          :items="driver_busList.map((b) => b.displayName)"
          ref="driver_bus"
          :rules="[
            (value) => rules.busDriverRequired(value, addRouteSchedulesInBulk),
          ]"
        ></v-autocomplete>
        <v-menu
          v-model="addRouteSchedulesInBulk.dateFromPickerMenu"
          :close-on-content-click="true"
          offset-y
          full-width
          prepend-icon="mdi-currency-usd"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="addRouteSchedulesInBulk.dateFrom"
              :value="formatedDate(addRouteSchedulesInBulk.dateFrom)"
              label="Start Date"
              prepend-icon="mdi-calendar"
              clearable
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="addRouteSchedulesInBulk.dateFrom"
          ></v-date-picker>
        </v-menu>
        <v-menu
          v-model="addRouteSchedulesInBulk.dateToPickerMenu"
          :close-on-content-click="true"
          offset-y
          full-width
          prepend-icon="mdi-currency-usd"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="addRouteSchedulesInBulk.dateTo"
              :value="formatedDate(addRouteSchedulesInBulk.dateTo)"
              label="End Date"
              prepend-icon="mdi-calendar"
              clearable
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="addRouteSchedulesInBulk.dateTo"
          ></v-date-picker>
        </v-menu>
        <v-select
          class="mb-2"
          v-model="addRouteSchedulesInBulk.term"
          label="Term"
          ref="routeScheduleTerm"
          :items="terms"
          :rules="[rules.required]"
        ></v-select>
        <v-card-actions class="mx-0 pr-0 pb-2 mt-2">
          <v-spacer></v-spacer>
          <v-btn
            color="default"
            dark
            @click="addRouteSchedulesInBulkDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click="saveRouteSchedulesInBulk"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card></v-dialog
    >

    <!-- <div v-if="updatingRoute">
            <update-route
                ref="updateRouteDialog"
                :rowClicked="rowClicked"
                :driver_busList="driver_busList"
                :loadRouteSchedules="loadRouteSchedules"
                :reloadGrid="reloadGrid"
            ></update-route>
        </div> -->

    <v-dialog persistent v-model="copyRoutesDialog" max-width="1250">
      <copy-season-routes
        :routes="selected"
        :reload="reloadGrid"
        :closeDialog="closeCopyRoutesDialog"
        :seasons="seasons"
        :selectedSeason="season"
        :terms="terms"
        :selectedTerm="regID"
      ></copy-season-routes>
    </v-dialog>

    <v-dialog persistent v-model="viewSeasonsDialog" max-width="700">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Route Seasons</v-card-title>

        <v-card-text class="pb-2">
          <div style="max-height: 500px; overflow-y: auto;">
            <v-card
              v-for="(season, index) in seasonData"
              :key="season.id"
              class="mb-3 season-card"
              elevation="2"
            >
              <v-card-text class="pb-2">
                <v-layout row wrap>
                  <v-flex xs12 class="mb-2">
                    <div class="subtitle-1 font-weight-bold success--text">
                      {{ season.season }}
                    </div>
                  </v-flex>
                  <v-flex xs6 class="mb-2">
                    <div class="caption grey--text">From Date</div>
                    <div class="body-2">{{ season.fromDate | date }}</div>
                  </v-flex>
                  <v-flex xs6 class="mb-2">
                    <div class="caption grey--text">To Date</div>
                    <div class="body-2">{{ season.toDate | date }}</div>
                  </v-flex>
                  <v-flex xs6 class="mb-2">
                    <div class="caption grey--text">Term</div>
                    <div class="body-2">{{ season.regID }}</div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </div>
        </v-card-text>

        <v-card-actions class="mx-0 px-2 pb-2 mt-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="viewSeasonsDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Record Message Dialog -->
    <v-dialog persistent v-model="recordDialog" max-width="500">
      <v-card class="pa-3">
        <v-card-title class="headline px-0 pt-0">Record Message</v-card-title>
        <v-card-text class="pa-0">
          <div class="mb-3">
            Please call <strong>718-690-2308</strong> and enter the following
            PIN number:
          </div>
          <div class="text-center mb-3">
            <v-chip color="primary" text-color="white" large class="headline">
              {{ pinNumber }}
            </v-chip>
          </div>
          <div class="mb-2" v-if="!recordingUrl">
            Once you have completed the recording, click the button below to
            retrieve it.
          </div>
          <div v-if="recordingError" class="text-danger mb-2">
            {{ recordingError }}
          </div>
          <div v-if="recordingUrl" class="mb-3">
            <div class="mb-2 font-weight-medium">Recording found:</div>
            <audio controls :src="recordingUrl" style="width: 100%;"></audio>
          </div>
        </v-card-text>
        <v-card-actions class="mr-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="closeRecordDialog()"
            >Cancel</v-btn
          >
          <v-btn
            v-if="!recordingUrl"
            :loading="checkingRecording"
            color="success"
            @click="checkRecording()"
          >
            Recording Done
          </v-btn>
          <v-btn v-if="recordingUrl" color="success" @click="attachRecording()">
            Attach Recording
          </v-btn>
          <v-btn
            v-if="recordingUrl"
            color="primary"
            @click="retryRecording()"
            class="ml-2"
          >
            Retry
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Send Text Message Dialog -->
    <v-dialog persistent v-model="sendTextMessageDialog" max-width="1000">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0 pb-3"
          >Send Text Message</v-card-title
        >
        <v-card-text class="pa-0">
          <v-layout row>
            <!-- Left Section: Driver List + Additional Numbers -->
            <v-flex xs6 class="pr-3 mb-2">
              <div class="font-weight-medium mb-2">
                Selected Drivers ({{ selectedDriversForMessage.length }}):
              </div>
              <div
                style="overflow-y: auto; max-height: 350px; border: 1px solid #e0e0e0; padding: 12px; border-radius: 4px;"
              >
                <div
                  v-for="(driver, index) in selectedDriversForMessage"
                  :key="index"
                  class="mb-3"
                  :class="{
                    'pb-3': index < selectedDriversForMessage.length - 1,
                  }"
                  :style="
                    index < selectedDriversForMessage.length - 1
                      ? 'border-bottom: 1px solid #e0e0e0;'
                      : ''
                  "
                >
                  <div class="mb-1">
                    <span class="font-weight-medium">Name:</span>
                    {{ driver.name }}
                  </div>
                  <div class="mb-1">
                    <span class="font-weight-medium">Position:</span>
                    {{ driver.position || "N/A" }}
                  </div>
                  <div class="mb-1">
                    <span class="font-weight-medium">Bus Number:</span>
                    {{ driver.busNumbers || "N/A" }}
                  </div>
                  <div class="mb-1">
                    <span class="font-weight-medium">Phone Number:</span>
                    <span
                      v-if="driver.phoneNumber && driver.phoneNumber.trim()"
                    >
                      {{ driver.phoneNumber }}
                    </span>
                    <span v-else class="text-warning">
                      Message will not be sent to this person (no phone number)
                    </span>
                  </div>
                </div>
              </div>
            </v-flex>
            <!-- Right Section: Message Box and Buttons -->
            <v-flex xs6 class="pl-3">
              <div class="mb-2">
                <v-text-field
                  label="From Number"
                  value="866-660-9260"
                  disabled
                  outline
                  class="mb-3"
                  hide-details
                ></v-text-field>
                <div class="text-warning mb-1" v-if="showEnterNotice()">
                  To move to the next line use the "shift + enter" keys
                </div>
                <v-textarea
                  @keydown="onKeyDown"
                  outline
                  rows="6"
                  label="Message"
                  v-model="textMessage"
                  ref="textMessage"
                  :rules="[rules.required, rules.maxMessageLength]"
                  class="mb-0"
                ></v-textarea>
                <div class="mb-2">
                  <span class="mx-1 font-weight-medium">Character count:</span>
                  {{ getMessageCount(textMessage) }}
                </div>
                <v-layout row class="mt-2">
                  <v-btn
                    small
                    color="info"
                    class="mr-2 mt-0"
                    @click="openAudioLibraryDialog()"
                  >
                    <v-icon left dark>mdi-library-music</v-icon>
                    Audio Library
                  </v-btn>
                  <v-btn
                    small
                    color="success"
                    class="mt-0"
                    @click="openRecordDialog()"
                  >
                    <v-icon left dark>mdi-microphone</v-icon>
                    Record Message
                  </v-btn>
                </v-layout>
                <div v-if="audioFile" class="mt-2">
                  <div class="caption grey--text mb-1">Selected Audio:</div>
                  <v-layout row align-center>
                    <audio
                      controls
                      :src="audioFile"
                      style="width: 100%; max-width: 380px;"
                    ></audio>
                    <v-btn icon small @click="removeAudioFile()" class="ml-2">
                      <v-icon color="error">mdi-close</v-icon>
                    </v-btn>
                  </v-layout>
                </div>
              </div>
              <v-card-actions class="pr-0 mr-0 pa-0 mt-3">
                <v-spacer></v-spacer>
                <v-btn
                  color="default"
                  dark
                  @click="closeSendTextMessageDialog()"
                  >Cancel</v-btn
                >
                <v-btn
                  :loading="sendingMessage"
                  color="success"
                  @click="sendTextMessage"
                >
                  Send Message
                </v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Audio Library Dialog -->
    <v-dialog persistent v-model="audioLibraryDialog" max-width="1000">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0 pb-2"
          >Audio Library</v-card-title
        >
        <v-layout row class="mb-3" align-center wrap>
          <div class="subtitle-2 font-weight-medium mr-3">
            Files ({{ audioLibraryFiltered.length }})
          </div>
          <v-text-field
            style="max-width: 210px;"
            label="Search"
            v-model="audioLibrarySearch"
            hide-details
            clearable
            class="mr-2 mt-0"
            @input="onAudioLibrarySearch()"
          ></v-text-field>
          <v-menu
            v-model="audioLibraryFromDateMenu"
            :close-on-content-click="true"
            offset-y
            full-width
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="audioLibraryFromDate"
                label="From Date"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
                class="mr-2 mt-0"
                style="max-width: 180px"
                hide-details
                clearable
                @click:clear="audioLibraryFromDateCleared()"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="audioLibraryFromDate"
              @change="onAudioLibraryFromDateChanged()"
            ></v-date-picker>
          </v-menu>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="success"
            class="mr-2 mt-0"
            :loading="audioLibraryUploading"
            @click="pickAudioLibraryFile()"
          >
            <v-icon left dark>mdi-cloud-upload</v-icon>
            Upload
          </v-btn>
          <v-btn
            small
            color="success"
            class="mt-0"
            :loading="loadingAudioLibrary"
            @click="loadAudioLibraryForDialog()"
          >
            <v-icon left dark>mdi-reload</v-icon>
            Reload
          </v-btn>
          <input
            type="file"
            style="display: none"
            ref="audioLibraryFile"
            accept=".mp3,.wav,audio/*"
            @change="onAudioLibraryFilePicked($event)"
          />
        </v-layout>

        <div style="height: 460px; overflow-y: auto;">
          <v-layout
            v-if="loadingAudioLibrary"
            justify-center
            align-center
            style="height: 100%;"
          >
            <v-progress-circular
              indeterminate
              color="success"
            ></v-progress-circular>
          </v-layout>
          <div v-else>
            <v-layout
              row
              class="pa-2 mb-2"
              align-center
              v-for="audio in audioLibraryPaginated"
              :key="audio.id"
              style="border: 1px solid #4caf50; border-radius: 4px;"
            >
              <!-- Info block -->
              <v-layout
                column
                class="mr-2"
                style="flex: 1; min-width: 0; overflow: hidden;"
              >
                <div class="mb-1" style="min-width: 0;">
                  <template v-if="!audio.editing">
                    <span
                      class="font-weight-medium body-2"
                      style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 220px; display: inline-block; vertical-align: middle;"
                      >{{ audio.name || "Unnamed" }}</span
                    >
                    <v-icon
                      style="cursor: pointer; color: #bdbdbd; vertical-align: middle; margin-left: 4px; font-size: 13px;"
                      @click.stop="editAudioLibraryName(audio)"
                      >mdi-pencil</v-icon
                    >
                  </template>
                  <template v-else>
                    <div
                      style="display: inline-flex; align-items: center; border: 1px solid #4caf50; border-radius: 4px; padding: 1px 4px; background: #fff;"
                      @click.stop
                    >
                      <input
                        v-model="audio.name"
                        style="border: none; outline: none; font-size: 14px; width: 210px; background: transparent;"
                        @click.stop
                        @keyup.enter.stop="saveAudioLibraryName(audio)"
                        @keyup.esc.stop="cancelAudioLibraryName(audio)"
                      />
                      <v-icon
                        small
                        style="cursor: pointer; color: #9e9e9e; margin-left: 4px;"
                        @click.stop="cancelAudioLibraryName(audio)"
                        title="Cancel"
                        >mdi-close</v-icon
                      >
                      <v-icon
                        small
                        style="cursor: pointer; color: #4caf50; margin-left: 2px;"
                        @click.stop="saveAudioLibraryName(audio)"
                        title="Save"
                        >mdi-check</v-icon
                      >
                    </div>
                  </template>
                </div>
                <div class="caption grey--text mb-1">
                  <span class="mr-2">{{ formatAudioDate(audio.date) }}</span>
                  <span v-if="audio.source" class="mr-2">
                    <v-icon x-small style="vertical-align: middle;"
                      >mdi-music-circle-outline</v-icon
                    >
                    {{ audio.source }}
                  </span>
                </div>
                <div class="caption grey--text">
                  <span v-if="audio.callerID" class="mr-2">
                    <v-icon x-small style="vertical-align: middle;"
                      >mdi-phone</v-icon
                    >
                    {{ formatPhone(audio.callerID) }}
                  </span>
                  <span v-if="audio.user" class="mr-2">
                    <v-icon x-small style="vertical-align: middle;"
                      >mdi-account</v-icon
                    >
                    {{ audio.user }}
                  </span>
                  <span
                    v-if="audio.branch"
                    class="d-inline-block"
                    style="max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: middle;"
                    :title="audio.branch"
                  >
                    <v-icon x-small style="vertical-align: middle;"
                      >mdi-source-branch</v-icon
                    >
                    {{ audio.branch }}
                  </span>
                </div>
              </v-layout>
              <!-- Player + actions -->
              <audio
                controls
                :src="audio.recordingURL"
                class="mr-2"
                style="height: 36px; flex-shrink: 0;"
              ></audio>
              <v-btn
                small
                color="success"
                class="mr-1 mt-0"
                style="flex-shrink: 0;"
                @click="selectAudioFromLibrary(audio)"
              >
                Select
              </v-btn>
              <v-btn
                icon
                small
                class="mt-0"
                style="flex-shrink: 0;"
                @click="openDeleteAudioLibraryItem(audio)"
              >
                <v-icon color="error" small>mdi-delete</v-icon>
              </v-btn>
            </v-layout>
            <div
              v-if="!audioLibraryPaginated.length && !loadingAudioLibrary"
              class="text-center grey--text pa-6"
            >
              No audio files found
            </div>
          </div>
        </div>

        <v-layout justify-center class="mt-2">
          <v-pagination
            v-model="audioLibraryPagination.page"
            :length="audioLibraryPages()"
            :total-visible="7"
            @input="setAudioLibraryPage()"
          ></v-pagination>
        </v-layout>

        <v-card-actions class="pr-0 pb-0 mt-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="audioLibraryDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Audio from Library confirm dialog -->
    <v-dialog persistent v-model="audioLibraryDeleteDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Delete Audio</v-card-title>
        <v-card-text class="py-2">
          You will delete
          <strong>{{
            audioLibraryToDelete && audioLibraryToDelete.name
          }}</strong
          >. This cannot be undone.
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="audioLibraryDeleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="audioLibraryDeleting"
            color="error"
            @click="deleteAudioLibraryItem()"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import AWS from "aws-sdk";
import DxDateBox from "devextreme-vue/date-box";
import { toISOLocal } from "../../utils/helpers.js";
import UpdateRoute from "./UpdateRoute.vue";
import CopySeasonRoutes from "./CopySeasonRoutes.vue";

export default {
  components: {
    DxDateBox,
    UpdateRoute,
    CopySeasonRoutes,
  },
  data: () => ({
    title: "Routes",

    actions: [],

    updateRouteDialog: false,
    addNewRouteDialog: false,

    updatingRoute: false,

    routeScheduleToAdd: {
      driver_bus: "",
      type: "Default",
      dateFromPickerMenu: false,
      dateFrom: "",
      dateToPickerMenu: false,
      dateTo: "",
      term: "",
    },

    routeScheduleToEdit: {},
    routeScheduleToDelete: {},
    routeScheduleEditDialog: false,
    routeScheduleDeleteDialog: false,
    addRouteScheduleDialog: false,
    addRouteSchedulesInBulkDialog: false,
    addRouteSchedulesInBulk: {
      type: "Default",
      driver_bus: "",
      dateFromPickerMenu: false,
      dateFrom: "",
      dateToPickerMenu: false,
      dateTo: "",
      term: "",
    },

    buildingList: [],
    gradeList: [],
    driver_busList: [],
    weekDayList: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
    ],

    rowClicked: {
      id: "",
      term: "",
      timeStart: "",
      direction: "",
      buildings: [],
      grades: [],
      description: "",
      color: "",
      notes: "",
      weekDays: [],
      routeSchedules: [],
      routeIdentifier: "",
      groupBy: "",
      geoSchedule: "",
      goeNotRequired: false,
    },

    newRoute: {
      id: "",
      term: "",
      timeStart: "",
      direction: "",
      color: "",
      notes: "",
      buildings: [],
      grades: [],
      description: "",
      weekDays: [],
      routeSchedules: [],
      routeIdentifier: "",
      groupBy: "",
      geoSchedule: "",
      goeNotRequired: false,
      season: "",
    },

    processing: false,
    deleteDialog: false,
    deleting: false,
    selected: [],
    files: [],
    url: "",
    terms: [],
    currentRegID: "",
    regID: "",
    geoScheduleOptions: [],
    seasons: [],
    seasonData: [],
    season: "",

    routeIdentifier: "",
    groupBy: "",
    updateGroupAndIdDialog: false,
    updateGeoScheduleDialog: false,
    bulkGeoSchedule: "",
    copyRoutesDialog: false,
    viewSeasonsDialog: false,
    sendTextMessageDialog: false,
    selectedDriversForMessage: [],
    textMessage: "",
    sendingMessage: false,
    audioFile: null,
    uploadingAudio: false,
    selectedLibraryAudioID: null,
    audioLibraryDialog: false,
    audioLibraryAll: [],
    audioLibraryFiltered: [],
    audioLibraryPaginated: [],
    audioLibrarySearch: "",
    audioLibraryFromDate: "",
    audioLibraryFromDateMenu: false,
    audioLibraryPagination: { page: 1, rowsPerPage: 8 },
    loadingAudioLibrary: false,
    audioLibraryUploading: false,
    audioLibraryDeleteDialog: false,
    audioLibraryToDelete: null,
    audioLibraryDeleting: false,
    recordDialog: false,
    pinNumber: "",
    checkingRecording: false,
    recordingUrl: null,
    recordingError: null,

    copyTo: {
      // season: "",
      // term: "",
      // type: "Default",
      // dateFromPickerMenu: false,
      // dateFrom: "",
      // dateToPickerMenu: false,
      // dateTo: "",
      schedules: [],
    },

    filterForToday: false,

    rules: {
      required: (value) => !!value || "Required.",
      phoneNumber: (v) => {
        return (
          !v ||
          ([10, 11].includes(v.replace(/-/g, "").length) &&
            /^\d+$/.test(v.replace(/-/g, ""))) ||
          "Invalid Phone Number"
        );
      },
      busDriverRequired: (value, routeSchedule) => {
        return (
          !routeSchedule.dateFrom ||
          !routeSchedule.dateTo ||
          !routeSchedule.type ||
          !!value ||
          "Required."
        );
      },
      routeScheduleTypeRequired: (value, routeSchedule) => {
        return (
          !routeSchedule.dateFrom ||
          !routeSchedule.dateFrom ||
          !routeSchedule.driver_bus ||
          !!value ||
          "Required."
        );
      },
      maxMessageLength: (value) => {
        if (!value) return true;
        let count = 0;
        for (let i = 0; i < value.length; i++) {
          let code = value.charCodeAt(i);
          if (code < 128) {
            count++;
          } else if (code < 2048) {
            count += 2;
          } else if (code < 65536) {
            count += 3;
          } else {
            count += 4;
          }
        }
        return count < 738 || "Max length is 737";
      },
    },

    columns: [
      // {
      //     label: "ID",
      //     field: "id",
      //     visible: true,
      //     filterValues: [],
      //     filterValue: null,
      //     selectedFilterOperation: null,
      // },
      {
        label: "Description",
        field: "description",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Term",
        field: "term",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Time Start",
        field: "timeStart",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        calculateSortValue: function(rowData) {
          return rowData.timeStartSort;
        },
      },
      {
        label: "Direction",
        field: "direction",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Buildings",
        field: "buildings",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Grades",
        field: "grades",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Week Days",
        field: "weekDays",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Driver",
        field: "driver",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Bus Number",
        field: "busNumber",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Color",
        field: "color",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Notes",
        field: "notes",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Route Identifier",
        field: "routeIdentifier",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Group",
        field: "groupBy",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Geo Schedule",
        field: "geoSchedule",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Date From",
        field: "dateFrom",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Date To",
        field: "dateTo",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "GOE Not Required",
        field: "goeNotRequired",
        type: "boolean",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  mounted() {},
  beforeDestroy() {},
  async created() {
    this.loadGrades();
    this.loadDriverBusList();

    const time = moment().toDate();
    time.setHours(8);
    time.setMinutes(0);
    time.setSeconds(0);
    time.setMilliseconds(0);
    //const currentTime = time.getTime();
    //const updatedTime = new Date(currentTime * 60 * 60 * 1000);

    //updatedTime.setMinutes(0);

    this.newRoute.timeStart = time;
  },
  methods: {
    async beforeSetupGrid() {
      await this.loadBuildings();

      this.actions.push({
        text: "Filter For Today",
        type: "switch",
        align: "left",
        action: this.onFilterByTodayChanged,
      });

      this.actions.push({
        text: "Actions",
        isMenu: true,
        items: [
          {
            value: "copy-season-routes",
            text: "Copy Season Routes",
          },
          {
            value: "add-group-and-id",
            text: "Add Group & ID",
          },
          {
            value: "add-Route-Schedule",
            text: "Add Route Schedule",
          },
          {
            value: "delete-routes",
            text: "Delete Routes",
          },
          {
            value: "add-route",
            text: "Add Route",
          },
          {
            value: "view-seasons",
            text: "View Seasons",
          },
          {
            value: "update-geo-schedule",
            text: "Update Geo Schedule",
          },
        ],
        value: "Actions",
        name: "Actions",
        action: this.openActionModal,
        //showOnSelection: true,
      });

      this.actions.push({
        text: "Send Text Message",
        action: this.openSendTextMessageDialog,
        showOnSelection: true,
      });

      await this.loadRegID();
      await this.loadGeoSchedules(this.regID);
      await this.loadTerms();
      await this.loadSeasons();
      await this.loadSeason();

      this.actions.push({
        text: "Select Term",
        type: "select",
        values: this.terms,
        value: this.regID,
        onSelected: this.onTermSelected,
      });

      this.actions.push({
        text: "Select Season",
        type: "select",
        values: this.seasons,
        value: this.season,
        onSelected: this.onSeasonSelected,
      });

      this.url =
        "route?regID=" +
        this.regID +
        "&filterByToday=" +
        this.filterForToday +
        "&season=" +
        this.season;
    },
    openActionModal(option) {
      const selected = this.$refs.grid.getSelectedRowsData();

      if (
        option != "add-route" &&
        option != "view-seasons" &&
        option != "update-geo-schedule" &&
        !selected.length
      ) {
        return this.$notify({
          group: "notification",
          text: "No Routes Selected",
          type: "error",
        });
      }

      switch (option) {
        case "copy-season-routes":
          return this.openCopySeasonRoutes();
        case "add-group-and-id":
          return this.openGroupAndIdDialog();
        case "add-Route-Schedule":
          return this.openAddRouteScheduleInBulk();
        case "delete-routes":
          return this.openDeleteRoutesDialog();
        case "add-route":
          return this.addRoute();
        case "view-seasons":
          return this.openViewSeasonsDialog();
        case "update-geo-schedule":
          return this.openUpdateGeoScheduleDialog();
      }
    },
    async onTermSelected(value) {
      this.regID = value;
      await this.loadGeoSchedules(this.regID);

      this.url =
        "route?regID=" +
        this.regID +
        "&filterByToday=" +
        this.filterForToday +
        "&season=" +
        this.season;

      this.$refs.grid.reloadDataSource(this.url);
    },
    getYearFromRegID(regID) {
      if (!regID) return "";

      const regIDAsString = String(regID).trim();
      const yearMatch = regIDAsString.match(/(\d{4})$/);

      return yearMatch ? yearMatch[1] : "";
    },
    getGeoScheduleOptions(selectedGeoSchedule) {
      const options = this.geoScheduleOptions.slice();
      const selectedValue = selectedGeoSchedule
        ? String(selectedGeoSchedule).trim()
        : "";

      if (selectedValue && options.indexOf(selectedValue) === -1) {
        options.unshift(selectedValue);
      }

      return options;
    },
    async loadGeoSchedules(regID) {
      const year = this.getYearFromRegID(regID);

      if (!year) {
        this.geoScheduleOptions = [];
        return;
      }

      try {
        const response = await this.$http.get(
          "api/studentStop/GetStudentStopSchedules?year=" + year
        );
        const geoSchedules = Array.isArray(response) ? response : [];

        this.geoScheduleOptions = geoSchedules
          .map((schedule) => (schedule === null ? "" : String(schedule).trim()))
          .filter((schedule) => !!schedule)
          .filter(
            (schedule, index, list) => list.indexOf(schedule) === index
          )
          .sort((a, b) => a.localeCompare(b));
      } catch (e) {
        this.geoScheduleOptions = [];
      }
    },
    onSeasonSelected(value) {
      this.season = value;

      localStorage.setItem("route-season", value);

      this.url =
        "route?regID=" +
        this.regID +
        "&filterByToday=" +
        this.filterForToday +
        "&season=" +
        this.season;

      this.$refs.grid.reloadDataSource(this.url);
    },
    onFilterByTodayChanged(value) {
      if (value) {
        this.filterForToday = value;

        this.url =
          "route?regID=" +
          this.regID +
          "&filterByToday=true" +
          "&season=" +
          this.season;
      } else {
        this.filterForToday = false;

        this.url =
          "route?regID=" +
          this.regID +
          "&filterByToday=" +
          "&season=" +
          this.season;
      }

      this.$refs.grid.reloadDataSource(this.url);
    },
    async loadBuildings() {
      const response = await this.$http.get(
        "/odata/buildings?$filter=inactive eq false or inactive eq null"
      );

      this.buildingList = response.value.map((b) => b.code).sort();

      this.$forceUpdate();
    },
    reloadGrid() {
      this.$refs.grid.reloadGrid();
    },
    async loadGrades() {
      const response = await this.$http.get("api/students/getGradeList");

      response.push("YG");

      this.gradeList = response.sort();
    },
    async loadTerms() {
      const terms = await this.$http.get("api/allStudents/getRegTerms");

      this.terms = terms;
    },
    async loadRegID() {
      this.currentRegID = await this.$http.get("api/allStudents/getRegID");
      this.regID = this.currentRegID;
    },
    async loadSeasons() {
      const seasons = await this.$http.get("api/route/getRouteSeasons");

      this.seasons = seasons.map((s) => s.season);
      this.seasonData = seasons;
    },
    async loadSeason() {
      // const season = await this.$http.get(
      //     "api/route/getCurrentRouteSeason",
      // );

      const season = localStorage.getItem("route-season");

      this.season = season ? season : this.seasons[0];
    },
    async loadDriverBusList() {
      const response = await this.$http.get("api/route/getDriverBusList");

      this.driver_busList = response
        .map((driverBus) => {
          driverBus.displayName =
            (driverBus.nameH ? driverBus.nameH : driverBus.name) +
            " - " +
            driverBus.busNumber;

          return driverBus;
        })
        .sort((a, b) => {
          const busNumberA = parseInt(a.busNumber) || 0;
          const busNumberB = parseInt(b.busNumber) || 0;
          return busNumberA - busNumberB;
        });
    },
    addRoute() {
      this.newRoute.term = this.currentRegID;
      this.newRoute.season = this.season;

      this.newRoute.routeSchedules = [];

      this.addNewRouteDialog = true;

      this.$refs.newDescription.resetValidation();
      this.$refs.newDirection.resetValidation();

      this.addRouteSchedule();
    },
    validateNewRoute() {
      const validations = [
        this.$refs.newDescription.validate(true),
        this.$refs.newDirection.validate(true),
        this.$refs.newRouteIdentifier.validate(true),
        this.$refs.newGroupBy.validate(true),
      ];

      this.$refs.newRouteDriver_bus.map((driver_bus) => {
        validations.push(driver_bus.validate(true));
      });

      // this.$refs.newRouteScheduleType.map((routeScheduleType) => {
      //     validations.push(routeScheduleType.validate(true));
      // });

      return validations.every(Boolean);
    },
    closeAddRouteDialog() {
      this.addNewRouteDialog = false;

      this.newRoute.id = "";
      this.newRoute.term = "";
      this.newRoute.direction = "";
      this.newRoute.color = "";
      this.newRoute.notes = "";
      this.newRoute.routeIdentifier = "";
      this.newRoute.groupBy = "";
      this.newRoute.geoSchedule = "";
      this.newRoute.description = "";
      this.newRoute.buildings = [];
      this.newRoute.grades = [];
      this.newRoute.weekDays = [];
      this.newRoute.routeSchedules = [];
      this.newRoute.goeNotRequired = false;
      this.newRoute.season = "";

      const time = moment().toDate();
      time.setHours(8);
      time.setMinutes(0);
      time.setSeconds(0);
      time.setMilliseconds(0);

      this.newRoute.timeStart = time;
    },
    async saveNewRoute() {
      if (!this.validateNewRoute()) return;

      if (!this.newRoute.buildings.length) {
        return this.$notify({
          text: "Missing Buildings",
          group: "notification",
          type: "error",
        });
      }

      if (!this.newRoute.timeStart) {
        return this.$notify({
          text: "Missing Time Start",
          group: "notification",
          type: "error",
        });
      }

      // if (
      //     this.newRoute.routeSchedules.filter(
      //         (schedule) => schedule.type == "Default",
      //     ).length > 1
      // ) {
      //     return this.$notify({
      //         text: "Can't have more than 1 Default route",
      //         group: "notification",
      //         type: "error",
      //     });
      // }

      const routeSchedules = this.newRoute.routeSchedules
        .filter((r) => r.driver_bus)
        .map((schedule) => {
          const driver_bus = this.driver_busList.find(
            (d) => d.displayName == schedule.driver_bus
          );

          return {
            id: schedule.id,
            driver_Bus_ID: driver_bus.id,
            type: schedule.type,
            term: schedule.term,
            dateFrom: schedule.dateFrom
              ? moment(schedule.dateFrom).format("L")
              : "",
            dateTo: schedule.dateTo ? moment(schedule.dateTo).format("L") : "",
          };
        });

      try {
        this.processing = true;

        await this.$http.post("api/route/save", {
          route: {
            term: this.newRoute.term,
            timeStart: this.getTimeStart(this.newRoute.timeStart),
            direction: this.newRoute.direction,
            buildings: this.newRoute.buildings.join(","),
            grades: this.newRoute.grades.join(","),
            description: this.newRoute.description,
            weekDays: this.sortWeekdays(this.newRoute.weekDays).join(","),
            color: this.newRoute.color,
            routeIdentifier: this.newRoute.routeIdentifier,
            groupBy: this.newRoute.groupBy,
            geoSchedule: this.newRoute.geoSchedule,
            notes: this.newRoute.notes,
            goeNotRequired: this.newRoute.goeNotRequired,
            season: this.newRoute.season,
          },
          routeSchedules,
        });

        this.processing = false;
        this.addNewRouteDialog = false;

        this.newRoute.direction = "";
        this.newRoute.buildings = [];
        this.newRoute.grades = [];
        this.newRoute.description = "";
        this.newRoute.weekDays = [];
        this.newRoute.routeSchedules = [];
        this.newRoute.geoSchedule = "";
        this.newRoute.goeNotRequired = false;

        const time = moment().toDate();
        time.setHours(8);
        time.setMinutes(0);
        time.setSeconds(0);
        time.setMilliseconds(0);

        this.newRoute.timeStart = time;

        this.$notify({
          group: "notification",
          text: "Route Saved",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        console.log(e);
        this.processing = false;
      }
    },
    sortWeekdays(days) {
      const weekdayOrder = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      return days.sort(
        (a, b) => weekdayOrder.indexOf(a) - weekdayOrder.indexOf(b)
      );
    },
    async onRowClicked(row) {
      const rowClicked = JSON.parse(JSON.stringify(row));

      rowClicked.buildings = rowClicked.buildings
        ? rowClicked.buildings.split(",")
        : [];
      rowClicked.grades = rowClicked.grades ? rowClicked.grades.split(",") : [];
      rowClicked.weekDays = rowClicked.weekDays
        ? rowClicked.weekDays.split(",")
        : [];

      let splitTime = rowClicked.timeStart.split(":"); //splitTime = ['06', '10 AM']
      let hour = parseInt(splitTime[0]); //Convert '06' to integer
      let minutes = parseInt(splitTime[1].split(" ")[0]); //Convert '10 AM' to integer

      if (splitTime[1].split(" ")[1] === "PM") {
        //If it is, add 12 hours to the hour variable
        hour += 12;
      }

      const currentDateTime = new Date();

      currentDateTime.setHours(hour);
      currentDateTime.setMinutes(minutes);

      rowClicked.timeStart = currentDateTime;

      await this.loadRouteSchedules(rowClicked);

      // if (!rowClicked.routeSchedules.length) {
      //     this.addRouteSchedule(rowClicked);
      // }

      this.rowClicked = rowClicked;

      this.updateRouteDialog = true;

      this.$forceUpdate();
    },
    closeUpdateRouteDialog() {
      this.updateRouteDialog = false;
    },
    async loadRouteSchedules(rowClicked = null) {
      const response = await this.$http.get(
        "api/route/getRouteSchedules?routeID=" +
          (rowClicked ? rowClicked.id : this.rowClicked.id)
      );

      const routeSchedules = response.map((routeSchedule) => {
        const driver_bus = this.driver_busList.find(
          (d) => d.id == routeSchedule.driver_Bus_ID
        );

        routeSchedule.driver_bus = driver_bus ? driver_bus.displayName : "";

        (routeSchedule.dateFrom = routeSchedule.dateFrom
          ? toISOLocal(new Date(routeSchedule.dateFrom)).substr(0, 10)
          : ""),
          (routeSchedule.dateTo = routeSchedule.dateTo
            ? toISOLocal(new Date(routeSchedule.dateTo)).substr(0, 10)
            : ""),
          (routeSchedule.dateToPickerMenu = false);
        routeSchedule.dateFromPickerMenu = false;

        return routeSchedule;
      });

      if (rowClicked) {
        rowClicked.routeSchedules = routeSchedules;
      } else {
        this.rowClicked.routeSchedules = routeSchedules;
      }

      this.$forceUpdate();
    },
    addRouteSchedule() {
      if (this.addNewRouteDialog) {
        this.newRoute.routeSchedules.push({
          driver_bus: "",
          type: "Default",
          dateFromPickerMenu: false,
          dateFrom: "",
          dateToPickerMenu: false,
          dateTo: "",
          term: this.currentRegID,
        });
      } else {
        this.rowClicked.routeSchedules.push({
          driver_bus: "",
          type: "Default",
          dateFromPickerMenu: false,
          dateFrom: "",
          dateToPickerMenu: false,
          dateTo: "",
          term: this.currentRegID,
        });
      }

      this.$forceUpdate();
    },
    removeRouteSchedule(index) {
      // if (this.addNewRouteDialog) {
      //     this.newRoute.routeSchedules.splice(index, 1);

      //     this.$forceUpdate();

      //     return;
      // }

      const obj = this.addNewRouteDialog ? "newRoute" : "rowClicked";

      if (index == 0) {
        this[obj].routeSchedules[index].driver_bus = "";
        this[obj].routeSchedules[index].type = "";
        this[obj].routeSchedules[index].dateFrom = "";
        this[obj].routeSchedules[index].dateTo = "";
      } else {
        this[obj].routeSchedules.splice(index, 1);
      }

      this.$forceUpdate();
    },
    openDeleteRouteSchedule(routeSchedule) {
      this.routeScheduleToDelete = routeSchedule;
      this.routeScheduleDeleteDialog = true;
    },
    editRouteSchedule(routeSchedule) {
      this.routeScheduleToEdit = JSON.parse(JSON.stringify(routeSchedule));
      this.routeScheduleEditDialog = true;
    },
    openAddRouteSchedule() {
      this.routeScheduleToAdd = {
        route_ID: this.rowClicked.id,
        driver_bus: "",
        type: "Default",
        dateFromPickerMenu: false,
        dateFrom: "",
        dateToPickerMenu: false,
        dateTo: "",
        term: this.currentRegID,
      };

      this.addRouteScheduleDialog = true;
    },
    openDeleteRoutesDialog() {
      this.selected = this.$refs.grid.getSelectedRowsData();

      this.deleteDialog = true;
    },
    async openAddRouteScheduleInBulk() {
      this.selected = this.$refs.grid.getSelectedRowsData();
      this.addRouteSchedulesInBulk.dateFrom = toISOLocal(new Date()).substr(
        0,
        10
      );
      this.addRouteSchedulesInBulk.term = this.currentRegID;
      this.addRouteSchedulesInBulkDialog = true;

      await this.loadSelectedRouteSchedules();
    },
    async loadSelectedRouteSchedules() {
      const ids = this.selected.map((s) => s.id);
      const response = await this.$http.post(
        "api/route/getRouteSchedulesForRouteIDs",
        ids
      );

      this.selected.forEach((route) => {
        route.routeSchedules = JSON.parse(
          JSON.stringify(response.filter((r) => r.route_ID == route.id))
        );

        const currentSchedule = route.routeSchedules.find(
          (r) => r.id == route.routeScheduleID
        );

        route.currentSchedule = currentSchedule;

        let driver_bus;

        if (currentSchedule) {
          driver_bus = this.driver_busList.find(
            (d) => d.id == currentSchedule.driver_Bus_ID
          );
        }

        route.newSchedule = {
          dateFromPickerMenu: false,
          dateToPickerMenu: false,
          dateFrom: "",
          dateTo: "",
          driver_bus: driver_bus ? driver_bus.displayName : "",
        };
      });

      this.$forceUpdate();
    },
    async saveRouteSchedulesInBulk() {
      if (!this.addRouteSchedulesInBulk.driver_bus) {
        return this.$notify({
          group: "notification",
          text: "Missing Driver / Bus.",
          type: "error",
        });
      }

      if (!this.addRouteSchedulesInBulk.dateFrom) {
        return this.$notify({
          group: "notification",
          text: "Missing start date.",
          type: "error",
        });
      }

      if (this.isDateFromLater(this.addRouteSchedulesInBulk)) {
        return this.$notify({
          group: "notification",
          text: "The start date must be before the end date.",
          type: "error",
        });
      }

      const isOverlapping = this.selected.some((routeSchedule) => {
        return this.isOverlapping(
          routeSchedule.routeSchedules,
          this.addRouteSchedulesInBulk
        );
      });

      if (isOverlapping) {
        return this.$notify({
          group: "notification",
          text:
            "There is another active schedule for the selected dates, please adjust.",
          type: "error",
        });
      }

      try {
        this.processing = true;

        const list = this.selected.map((route) => {
          const data = JSON.parse(JSON.stringify(this.addRouteSchedulesInBulk));

          const driver_bus = this.driver_busList.find(
            (d) => d.displayName == this.addRouteSchedulesInBulk.driver_bus
          );

          data.driver_Bus_ID = driver_bus.id;
          data.route_ID = route.id;

          delete data.driver_bus;

          return data;
        });

        await this.$http.post("api/route/saveRouteSchedulesInBulk", list);

        this.addRouteSchedulesInBulkDialog = false;

        this.processing = false;

        this.$notify({
          group: "notification",
          text: "Changes Saved",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        console.log(e);
        this.processing = false;
      }
    },
    async deleteRoutes() {
      try {
        const ids = this.selected.map((s) => s.id);

        this.processing = true;

        await this.$http.post("api/route/delete", ids);

        this.processing = false;
        this.deleteDialog = false;

        this.$notify({
          group: "notification",
          text: ids.length + " Routes Deleted",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    formatedDate(date) {
      return date ? moment(date).format("L") : "";
    },
    validate() {
      const validations = [
        this.$refs.description.validate(true),
        this.$refs.direction.validate(true),
      ];

      // this.$refs.driver_bus.map((driver_bus) => {
      //     validations.push(driver_bus.validate(true));
      // });

      // this.$refs.routeScheduleType.map((routeScheduleType) => {
      //     validations.push(routeScheduleType.validate(true));
      // });

      return validations.every(Boolean);
    },
    async saveRoute() {
      if (!this.validate()) return;

      if (
        this.rowClicked.routeSchedules.some(
          (schedule) =>
            schedule.dateFrom &&
            schedule.dateTo &&
            new Date(schedule.dateFrom) > new Date(schedule.dateTo)
        )
      ) {
        return this.$notify({
          text: "From Date is later than the To Date",
          group: "notification",
          type: "error",
        });
      }

      // if (
      //     this.rowClicked.routeSchedules.filter(
      //         (schedule) => schedule.type == "Default",
      //     ).length > 1
      // ) {
      //     return this.$notify({
      //         text: "Can't have more than 1 Default route",
      //         group: "notification",
      //         type: "error",
      //     });
      // }

      try {
        this.processing = true;

        const routeSchedules = this.rowClicked.routeSchedules
          .filter((r) => r.driver_bus)
          .map((schedule) => {
            const driver_bus = this.driver_busList.find(
              (d) => d.displayName == schedule.driver_bus
            );

            return {
              id: schedule.id,
              driver_Bus_ID: driver_bus.id,
              type: schedule.type,
              term: schedule.term,
              dateFrom: schedule.dateFrom
                ? moment(schedule.dateFrom).format("L")
                : "",
              dateTo: schedule.dateTo
                ? moment(schedule.dateTo).format("L")
                : "",
            };
          });

        await this.$http.post("api/route/save", {
          route: {
            id: this.rowClicked.id,
            term: this.rowClicked.term,
            timeStart: this.getTimeStart(this.rowClicked.timeStart),
            direction: this.rowClicked.direction,
            buildings: this.rowClicked.buildings.join(","),
            grades: this.rowClicked.grades.join(","),
            description: this.rowClicked.description,
            weekDays: this.sortWeekdays(this.rowClicked.weekDays).join(","),
            color: this.rowClicked.color,
            notes: this.rowClicked.notes,
            routeIdentifier: this.rowClicked.routeIdentifier,
            groupBy: this.rowClicked.groupBy,
            geoSchedule: this.rowClicked.geoSchedule,
            goeNotRequired: this.rowClicked.goeNotRequired,
          },
          routeSchedules,
        });

        this.$notify({
          group: "notification",
          text: "Changes Saved",
          type: "success",
        });

        this.updateRouteDialog = false;
        this.processing = false;

        this.$refs.grid.reloadGrid();
      } catch (e) {
        console.log(e);
        this.processing = false;
      }
    },
    openGroupAndIdDialog() {
      this.selected = this.$refs.grid.getSelectedRowsData();
      this.updateGroupAndIdDialog = true;
    },
    async openCopySeasonRoutes() {
      this.selected = this.$refs.grid.getSelectedRowsData();

      await this.loadSelectedRouteSchedules();

      this.copyRoutesDialog = true;

      this.$forceUpdate();
    },
    closeCopyRoutesDialog() {
      this.copyRoutesDialog = false;
    },
    openViewSeasonsDialog() {
      this.viewSeasonsDialog = true;
    },
    async saveGroupAndID() {
      try {
        this.processing = true;

        await this.$http.post("api/route/saveGroupAndID", {
          ids: this.selected.map((s) => s.id),
          routeIdentifier: this.routeIdentifier,
          groupBy: this.groupBy,
        });

        this.$notify({
          group: "notification",
          text: "Changes Saved",
          type: "success",
        });

        this.updateGroupAndIdDialog = false;
        this.processing = false;

        this.$refs.grid.reloadGrid();
      } catch (e) {
        console.log(e);
      }
    },
    openUpdateGeoScheduleDialog() {
      this.selected = this.$refs.grid.getSelectedRowsData();
      this.bulkGeoSchedule = "";
      this.updateGeoScheduleDialog = true;
    },
    async saveGeoSchedule() {
      try {
        this.processing = true;

        await this.$http.post("api/route/SaveGeoSchedule", {
          ids: this.selected.map((s) => s.id),
          geoSchedule: this.bulkGeoSchedule,
        });

        this.$notify({
          group: "notification",
          text: "Geo Schedule Updated",
          type: "success",
        });

        this.updateGeoScheduleDialog = false;
        this.processing = false;

        this.$refs.grid.reloadGrid();
      } catch (e) {
        console.log(e);
        this.processing = false;
      }
    },
    getTimeStart(value) {
      var date = new Date(value);
      var hour = date.getHours();
      var minutes = date.getMinutes();

      // Convert to 12-hour clock
      var period = hour >= 12 ? "PM" : "AM";
      hour = hour > 12 ? hour - 12 : hour;
      hour = hour === 0 ? 12 : hour;

      // Format minutes
      if (minutes < 10) {
        minutes = "0" + minutes;
      }

      return hour + ":" + minutes + " " + period;
    },
    isOverlapping(routeSchedules, scheduleToEdit) {
      for (let i = 0; i < routeSchedules.length; i++) {
        // check if scheduleToEdit date range overlaps with any other schedule
        if (
          scheduleToEdit.dateFrom >= routeSchedules[i].dateFrom &&
          scheduleToEdit.dateFrom < routeSchedules[i].dateTo &&
          routeSchedules[i].dateTo !== null
        ) {
          // scheduleToEdit overlaps with this schedule, return true
          return true;
        }
        if (
          scheduleToEdit.dateTo !== null &&
          scheduleToEdit.dateTo >= routeSchedules[i].dateFrom &&
          scheduleToEdit.dateTo < routeSchedules[i].dateTo
        ) {
          // scheduleToEdit overlaps with this schedule, return true
          return true;
        }
        // check if any other schedules has a null dateTo - meaning it runs till end of time
        if (
          scheduleToEdit.dateTo === null &&
          routeSchedules[i].dateTo === null
        ) {
          // overlapping as both schedules run till end of time
          return true;
        }
      }

      // if no overlaps, return false
      return false;
    },
    isDateFromLater(routeSchedule) {
      if (!routeSchedule.dateTo) return;

      if (routeSchedule.dateFrom > routeSchedule.dateTo) {
        return true;
      } else {
        return false;
      }
    },
    async saveRouteSchedule({ routeSchedule }) {
      if (!routeSchedule.driver_bus) {
        return this.$notify({
          group: "notification",
          text: "Missing Driver / Bus.",
          type: "error",
        });
      }

      if (!routeSchedule.dateFrom) {
        return this.$notify({
          group: "notification",
          text: "Missing start date.",
          type: "error",
        });
      }

      if (this.isDateFromLater(routeSchedule)) {
        return this.$notify({
          group: "notification",
          text: "The start date must be before the end date.",
          type: "error",
        });
      }

      if (
        this.isOverlapping(
          this.rowClicked.routeSchedules.filter(
            (r) => r.id != routeSchedule.id
          ),
          routeSchedule
        )
      ) {
        return this.$notify({
          group: "notification",
          text:
            "There is another active schedule for the selected dates, please adjust.",
          type: "error",
        });
      }

      try {
        this.processing = true;

        const data = JSON.parse(JSON.stringify(routeSchedule));

        const driver_bus = this.driver_busList.find(
          (d) => d.displayName == routeSchedule.driver_bus
        );

        data.driver_Bus_ID = driver_bus.id;

        delete data.driver_bus;

        await this.$http.post("api/route/saveRouteSchedule", data);

        this.routeScheduleEditDialog = false;
        this.addRouteScheduleDialog = false;

        this.processing = false;

        this.loadRouteSchedules();

        this.$notify({
          group: "notification",
          text: "Changes Saved",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    async deleteRouteSchedule() {
      try {
        this.processing = true;

        await this.$http.post(
          "api/route/deleteRouteSchedule?id=" + this.routeScheduleToDelete.id
        );

        this.routeScheduleDeleteDialog = false;

        this.processing = false;

        this.loadRouteSchedules();

        this.$notify({
          group: "notification",
          text: "Route Schedule Deleted",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    closeSendTextMessageDialog() {
      this.sendTextMessageDialog = false;
      this.textMessage = "";
      this.selectedDriversForMessage = [];
      this.audioFile = null;
      this.selectedLibraryAudioID = null;
    },
    formatPhone(phone) {
      if (!phone) return "";
      const cleaned = phone.replace(/\D/g, "");
      if (cleaned.length === 11) {
        return (
          "+1 (" +
          cleaned.substring(1, 4) +
          ") " +
          cleaned.substring(4, 7) +
          "-" +
          cleaned.substring(7)
        );
      } else if (cleaned.length === 10) {
        return (
          "(" +
          cleaned.substring(0, 3) +
          ") " +
          cleaned.substring(3, 6) +
          "-" +
          cleaned.substring(6)
        );
      }
      return phone;
    },
    formatAudioDate(date) {
      if (!date) return "";
      return moment(date).format("MM/DD/YY h:mm A");
    },
    openAudioLibraryDialog() {
      this.audioLibrarySearch = "";
      this.audioLibraryFromDate = "";
      this.audioLibraryPagination.page = 1;
      this.audioLibraryDialog = true;
      this.loadAudioLibraryForDialog();
    },
    async loadAudioLibraryForDialog() {
      this.loadingAudioLibrary = true;

      try {
        const response = await this.$http.get("api/broadcast/getAudioLibrary");

        this.audioLibraryAll = (response || [])
          .map((audio) => {
            audio.name = audio.name ? audio.name : "Unnamed";
            audio.editing = false;
            audio.originalName = audio.name;
            return audio;
          })
          .filter((audio) => {
            const userBranch = this.$store.state.authentication.branch;
            if (userBranch && !userBranch.includes("null")) {
              const branches = userBranch.split(",");
              const audioBranches = audio.branch ? audio.branch.split(",") : [];
              return (
                audio.branch &&
                (branches.some((b) => b == audio.branch) ||
                  audioBranches.some((ab) => branches.some((br) => br == ab)))
              );
            }
            return true;
          });

        this.audioLibraryFiltered = this.audioLibraryAll;
        this.setAudioLibraryPage();
      } catch (e) {
        this.$notify({
          text: "Failed to load audio library",
          group: "notification",
          type: "error",
        });
      } finally {
        this.loadingAudioLibrary = false;
      }
    },
    onAudioLibrarySearch() {
      const search =
        this.audioLibrarySearch && this.audioLibrarySearch.toLowerCase();
      let filtered = this.audioLibraryAll;

      if (search) {
        filtered = filtered.filter(
          (a) => a.name && a.name.toLowerCase().includes(search)
        );
      }

      if (this.audioLibraryFromDate) {
        const fromDate = new Date(this.audioLibraryFromDate);
        filtered = filtered.filter((a) => new Date(a.date) >= fromDate);
      }

      this.audioLibraryFiltered = filtered;
      this.audioLibraryPagination.page = 1;
      this.setAudioLibraryPage();
    },
    onAudioLibraryFromDateChanged() {
      this.onAudioLibrarySearch();
    },
    audioLibraryFromDateCleared() {
      this.audioLibraryFromDate = "";
      this.onAudioLibrarySearch();
    },
    audioLibraryPages() {
      if (!this.audioLibraryPagination.rowsPerPage) return 0;
      return Math.ceil(
        this.audioLibraryFiltered.length /
          this.audioLibraryPagination.rowsPerPage
      );
    },
    setAudioLibraryPage() {
      const start =
        (this.audioLibraryPagination.page - 1) *
        this.audioLibraryPagination.rowsPerPage;
      this.audioLibraryPaginated = this.audioLibraryFiltered.slice(
        start,
        start + this.audioLibraryPagination.rowsPerPage
      );
    },
    editAudioLibraryName(audio) {
      audio.originalName = audio.name;
      audio.editing = true;
    },
    cancelAudioLibraryName(audio) {
      audio.name = audio.originalName ? audio.originalName : audio.name;
      audio.editing = false;
    },
    async saveAudioLibraryName(audio) {
      const updatedName = audio.name && audio.name.trim();
      if (!updatedName) {
        this.$notify({
          text: "Audio name cannot be empty",
          group: "notification",
          type: "error",
        });
        return;
      }

      try {
        await this.$http.post(
          "api/broadcast/updateAudioName?id=" +
            audio.id +
            "&name=" +
            encodeURIComponent(updatedName)
        );
        audio.name = updatedName;
        audio.originalName = updatedName;
        audio.editing = false;
        this.$notify({
          text: "Audio name updated",
          group: "notification",
          type: "success",
        });
      } catch (e) {
        audio.name = audio.originalName ? audio.originalName : audio.name;
        audio.editing = false;
        this.$notify({
          text: "Failed to update audio name",
          group: "notification",
          type: "error",
        });
      }
    },
    pickAudioLibraryFile() {
      this.$refs.audioLibraryFile.click();
    },
    async onAudioLibraryFilePicked(e) {
      if (!e.target.files || !e.target.files.length) return;

      const file = e.target.files[0];

      this.audioLibraryUploading = true;

      try {
        const formData = new FormData();
        formData.append("upload_file", file);

        const response = await this.$http.post(
          "api/broadcast/uploadAudioFile?user=" +
            this.$store.state.authentication.user,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        this.$notify({
          text: "Audio file uploaded successfully",
          group: "notification",
          type: "success",
        });

        await this.loadAudioLibraryForDialog();

        if (response && response.audio) {
          this.selectAudioFromLibrary(response.audio);
        }
      } catch (e) {
        this.$notify({
          text: "Failed to upload audio file",
          group: "notification",
          type: "error",
        });
      } finally {
        this.audioLibraryUploading = false;
        if (this.$refs.audioLibraryFile) {
          this.$refs.audioLibraryFile.value = "";
        }
      }
    },
    selectAudioFromLibrary(audio) {
      this.audioFile = audio.recordingURL;
      this.selectedLibraryAudioID = audio.id;
      this.audioLibraryDialog = false;
      this.$notify({
        text: "Audio selected: " + audio.name,
        group: "notification",
        type: "success",
      });
    },
    openDeleteAudioLibraryItem(audio) {
      this.audioLibraryToDelete = audio;
      this.audioLibraryDeleteDialog = true;
    },
    async deleteAudioLibraryItem() {
      this.audioLibraryDeleting = true;

      try {
        await this.$http.post(
          "api/broadcast/deleteAudio?id=" + this.audioLibraryToDelete.id
        );

        this.audioLibraryDeleteDialog = false;

        this.$notify({
          text: "Audio deleted",
          group: "notification",
          type: "success",
        });

        await this.loadAudioLibraryForDialog();
      } catch (e) {
        this.$notify({
          text: "Failed to delete audio",
          group: "notification",
          type: "error",
        });
      } finally {
        this.audioLibraryDeleting = false;
      }
    },
    async openSendTextMessageDialog() {
      const selected = this.$refs.grid.getSelectedRowsData();

      if (!selected || !selected.length) {
        this.$notify({
          text: "No routes selected",
          group: "notification",
          type: "error",
        });
        return;
      }

      try {
        // Extract unique driver_Bus_IDs from selected routes
        const driver_Bus_IDs = [
          ...new Set(
            selected.map((r) => r.driver_Bus_ID).filter((id) => id != null)
          ),
        ];

        if (!driver_Bus_IDs.length) {
          this.$notify({
            text: "No drivers found for selected routes",
            group: "notification",
            type: "error",
          });
          return;
        }

        // Get drivers by driver_Bus_IDs
        const driversResponse = await this.$http.post(
          "api/drivers/GetDriversByDriverBusIds",
          driver_Bus_IDs
        );

        this.selectedDriversForMessage = driversResponse || [];
        this.textMessage = "";
        this.audioFile = null;
        this.selectedLibraryAudioID = null;
        this.sendTextMessageDialog = true;
      } catch (e) {
        this.$notify({
          text: "Failed to load drivers",
          group: "notification",
          type: "error",
        });
      }
    },
    getMessageCount(value) {
      if (!value) return 0;

      let count = 0;
      for (let i = 0; i < value.length; i++) {
        let code = value.charCodeAt(i);
        if (code < 128) {
          count++;
        } else if (code < 2048) {
          count += 2;
        } else if (code < 65536) {
          count += 3;
        } else {
          count += 4;
        }
      }

      return count;
    },
    showEnterNotice() {
      const users = [
        "12561@utaw.org",
        "256@utaw.org",
        "258@utaw.org",
        "257@utaw.org",
        "jwercberger@utaw.org",
      ];

      return users.includes(this.$store.state.authentication.user);
    },
    onKeyDown(event) {
      const users = [
        "12561@utaw.org",
        "256@utaw.org",
        "257@utaw.org",
        "258@utaw.org",
        "jwercberger@utaw.org",
      ];

      if (users.includes(this.$store.state.authentication.user)) {
        if (event.keyCode === 13 && !event.shiftKey) {
          event.stopPropagation();
          event.preventDefault();
        }
      }
    },
    async sendTextMessage() {
      if (this.$refs.textMessage && !this.$refs.textMessage.validate(true))
        return;

      if (!this.textMessage) {
        this.$notify({
          text: "Message Required",
          group: "notification",
          type: "error",
        });
        return;
      }

      try {
        this.sendingMessage = true;

        // Filter drivers with phone numbers and create numbers array
        const numbers = this.selectedDriversForMessage
          .filter(
            (driver) => driver.phoneNumber && driver.phoneNumber.trim() !== ""
          )
          .map((driver) => {
            const phoneNumber = driver.phoneNumber.replace(/-/g, "");

            return {
              accountID: driver.employeeID || driver.id,
              number: phoneNumber,
            };
          });

        if (numbers.length === 0) {
          this.$notify({
            text: "No drivers with phone numbers selected",
            group: "notification",
            type: "error",
          });
          this.sendingMessage = false;
          return;
        }

        const isLocalhost =
          window.location.hostname === "localhost" ||
          window.location.hostname === "127.0.0.1";
        const url = isLocalhost
          ? "https://localhost:7197/broadcast/broadcastMessage"
          : "https://broadcast-3t6ck5zrrq-ue.a.run.app/broadcast/broadcastMessage";

        await this.$http.post(url, {
          from: "18666609260",
          broadcastID: null,
          user: this.$store.state.authentication.user,
          types: [],
          attachmentRecording: this.audioFile || null,
          audioID: this.selectedLibraryAudioID,
          text: this.textMessage,
          broadcastName:
            "Driver_Route_Text_Message_" + moment().format("MM_DD_YYYY"),
          confirmListing: false,
          repeat: 2,
          isTest: false,
          testNumber: "",
          requestID: 0,
          isMenahalBroadcast: true,
          numbers: numbers,
          branch: "BUS - באס",
          grade: "",
          numberSelectionMode: "manualEntry",
          accountsSource: "TUITION",
          broadcastTime: null,
        });

        this.$notify({
          text: "Text message sent successfully",
          group: "notification",
          type: "success",
        });

        this.sendTextMessageDialog = false;
        this.textMessage = "";
        this.selectedDriversForMessage = [];
        this.audioFile = null;
        this.selectedLibraryAudioID = null;
      } catch (e) {
        this.$notify({
          text: "Failed to send text message",
          group: "notification",
          type: "error",
        });
      } finally {
        this.sendingMessage = false;
      }
    },
    async convertToMp3(url) {
      try {
        const response = await this.$http.post(
          `api/adminportal/ConvertToMp3?url=${encodeURIComponent(url)}`
        );
        // Handle different response formats: could be string URL or object with url property
        return response;
      } catch (e) {
        // If conversion fails, return original URL
        console.error("Failed to convert to MP3:", e);
        this.$notify({
          text: "Warning: Failed to convert audio to MP3, using original file",
          group: "notification",
          type: "warning",
        });
        return url;
      }
    },
    removeAudioFile() {
      this.audioFile = null;
      this.selectedLibraryAudioID = null;
    },
    async openRecordDialog() {
      this.recordDialog = true;
      this.pinNumber = "";
      this.recordingUrl = null;
      this.recordingError = null;

      try {
        const user = this.$store.state.authentication.user;
        const pin = await this.$http.post(
          `api/broadcast/GenerateRecordingPin?user=${user}`
        );
        this.pinNumber = pin;
      } catch (e) {
        this.$notify({
          text: "Failed to generate PIN number",
          group: "notification",
          type: "error",
        });
        this.recordDialog = false;
      }
    },
    closeRecordDialog() {
      this.recordDialog = false;
      this.pinNumber = "";
      this.recordingUrl = null;
      this.recordingError = null;
    },
    async checkRecording() {
      if (!this.pinNumber) {
        this.recordingError = "PIN number is required";
        return;
      }

      this.checkingRecording = true;
      this.recordingError = null;

      try {
        const response = await this.$http.get(
          `api/broadcast/GetRecording?pin=${this.pinNumber}`
        );

        // API returns { recording: "url", ... }
        if (response && response.recording) {
          // Convert recording to MP3
          const convertedUrl = await this.convertToMp3(response.recording);
          this.recordingUrl = convertedUrl;
          this.$notify({
            text: "Recording retrieved successfully",
            group: "notification",
            type: "success",
          });
          // Keep dialog open so user can preview the recording
        } else {
          this.recordingError =
            "Recording not found. Please make sure you completed the call and entered the correct PIN.";
        }
      } catch (e) {
        this.recordingError =
          "Recording not found. Please make sure you completed the call and entered the correct PIN.";
      } finally {
        this.checkingRecording = false;
      }
    },
    attachRecording() {
      if (this.recordingUrl) {
        this.audioFile = this.recordingUrl;
        this.selectedLibraryAudioID = null;
        this.closeRecordDialog();
        this.$notify({
          text: "Recording attached to message",
          group: "notification",
          type: "success",
        });
      }
    },
    async retryRecording() {
      // Reset and generate new PIN
      this.recordingUrl = null;
      this.recordingError = null;
      this.pinNumber = "";

      try {
        const user = this.$store.state.authentication.user;
        const pin = await this.$http.post(
          `api/broadcast/GenerateRecordingPin?user=${user}`
        );
        this.pinNumber = pin;
        this.$notify({
          text: "New PIN generated. Please call again with the new PIN.",
          group: "notification",
          type: "info",
        });
      } catch (e) {
        this.$notify({
          text: "Failed to generate new PIN number",
          group: "notification",
          type: "error",
        });
      }
    },
  },
};
</script>
<style>
.gray-fg {
  color: #999;
}
.toggle-button {
  font-size: 15px;
  padding: 5px !important;
}
.toggle-button-group {
  border-radius: 10px;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active {
  background-color: #afecb2 !important;
  color: #4caf50 !important;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active.default-schedule-button {
  border-radius: 10px 0px 0px 10px;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active.sub-schedule-button {
  border-radius: 0px 10px 10px 0px;
}
.season-card {
  border: 2px solid #4caf50 !important;
  border-left: 5px solid #4caf50 !important;
  transition: all 0.3s ease;
}
.season-card:hover {
  border-color: #2e7d32 !important;
  box-shadow: 0 4px 8px rgba(76, 175, 80, 0.3) !important;
}
</style>
